var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "navbar-item navbar-show-on-top" }, [
    _c("span", [_vm._v(_vm._s(_vm.$t("menu.promo_code")))]),
    _c("div", { staticClass: "buttons" }, [
      _c(
        "a",
        {
          staticClass: "button is-primary is-fastweb button-height-navbar",
          on: { click: _vm.goPromoCode },
        },
        [_vm._m(0)]
      ),
      _c(
        "a",
        {
          staticClass: "button is-primary is-agos button-height-navbar",
          on: { click: _vm.goPromoCode },
        },
        [_vm._m(1)]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "navbar-partner-logo" }, [
        _c("img", { attrs: { src: "/img/fastweb_small.png" } }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "navbar-partner-logo" }, [
        _c("img", { attrs: { src: "/img/agos_small.png" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }